module.exports = __webpack_public_path__ + "static/media/add-pink.b1f20a46.svg";